import { ConfirmPopup, Text } from '~/commonComponents';
import AnimatedCheckCircle from '~/components/shared/AnimatedCheckCircle';
import { Colors } from '~/themes/colors';

const SuccessIconComponent = () => <AnimatedCheckCircle />;

interface IHireCandidateSuccessPopupProps {
  onClose: () => void;
}

export const HireCandidateSuccessPopup = ({
  onClose,
}: IHireCandidateSuccessPopupProps) => (
  // @ts-expect-error - ConfirmPopup still written in JavaScript
  <ConfirmPopup
    Icon={SuccessIconComponent}
    title="Congratulations on Your Hire!"
    titleStyle={{ marginTop: 21, marginBottom: 16 }}
    description={
      <Text color={Colors.neutral_500}>
        The candidate's status has been updated and moved to
        <br />
        the Hired tab. We're glad GoTu helped you find the
        <br />
        right professional for your team.
      </Text>
    }
    descriptionStyle={{ width: '100%', marginBottom: 38 }}
    modalStyle={{ width: 560 }}
    rightButtonText="Done"
    rightButtonAction={onClose}
  />
);
